export default __webpack_public_path__ + "static/media/confirmation-fintro.8a3f6cdf.svg";